var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('v-img',{staticClass:"mt-3",attrs:{"src":_vm.image,"max-height":"80vh","contain":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }